import React, { useState, useEffect } from "react";
import Showimage from "./ShowImage";
import Vote from "./commentaire/vote";
import { isAuthenticated, updateItem, removeItem } from "../auth";
import { MdDelete } from "react-icons/md";
import { FaPlus, FaMinus } from "react-icons/fa";
import { FiDelete } from "react-icons/fi";
import Price from "./productsPrice";
import ShippingCart from "../pageInside/shippingCart";
import { elakayAutoText } from "./dataElakay";

const CardCart = ({
  shipAmout,
  SetShipAmount,
  Saddress,
  countProuct,
  product,
  CataID,
  laguangeElakay,
  infoSource,
}) => {
  const { cartItems } = infoSource;
  const { token } = isAuthenticated();
  const CartID = product.cartID;
  const catalID = CataID ? CataID : product.categoryID;

  const [isUpdating, setIsUpdating] = useState(false);

  // Styles avec animations
  const styles = {
    card: {
      background: "linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)",
      borderRadius: "14px",
      border: "1px solid #e2e8f0",
      padding: "1rem",
      marginBottom: "1rem",
      boxShadow: "0 2px 8px rgba(0, 115, 153, 0.08)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      display: "flex",
      gap: "1rem",
      position: "relative",
      overflow: "hidden",
    },
    imageContainerOuter: {
      flexShrink: 0,
      position: "relative",
    },
    imageContainer: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      overflow: "hidden",
      borderRadius: "10px",
    },
    contentWrapper: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: "0.65rem",
      minWidth: 0,
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "0.75rem",
    },
    productName: {
      fontSize: "1.0625rem",
      fontWeight: 600,
      color: "#1e293b",
      margin: 0,
      lineHeight: 1.4,
      wordBreak: "break-word",
    },
    deleteButton: {
      padding: "0.5rem",
      background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
      border: "1px solid #fee2e2",
      borderRadius: "10px",
      color: "#ef4444",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      fontSize: "1.25rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      boxShadow: "0 2px 4px rgba(239, 68, 68, 0.1)",
    },
    filterText: {
      fontSize: "0.8125rem",
      color: "#64748b",
      margin: 0,
      padding: "0.35rem 0.75rem",
      background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
      borderRadius: "6px",
      display: "inline-block",
    },
    controlsRow: {
      display: "flex",
      alignItems: "center",
      gap: "0.75rem",
      flexWrap: "wrap",
    },
    quantityControl: {
      display: "inline-flex",
      alignItems: "center",
      border: "1px solid #e2e8f0",
      borderRadius: "10px",
      overflow: "hidden",
      background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      boxShadow: "0 2px 6px rgba(0, 115, 153, 0.08)",
    },
    quantityButton: {
      padding: "0.5rem 0.75rem",
      border: "none",
      background: "transparent",
      color: "#1e293b",
      cursor: "pointer",
      transition: "all 0.25s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "0.9rem",
    },
    quantityInput: {
      width: "55px",
      textAlign: "center",
      border: "none",
      borderLeft: "1px solid #e2e8f0",
      borderRight: "1px solid #e2e8f0",
      padding: "0.5rem 0.25rem",
      fontSize: "0.9375rem",
      fontWeight: 600,
      outline: "none",
      background: "transparent",
      color: "#007399",
    },
    priceWrapper: {
      fontSize: "1.125rem",
      fontWeight: 700,
      color: "#007399",
      padding: "0.35rem 0.75rem",
      background: "linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)",
      borderRadius: "8px",
    },
    infoRow: {
      display: "flex",
      alignItems: "center",
      gap: "0.75rem",
      flexWrap: "wrap",
    },
    voteWrapper: {
      fontSize: "0.875rem",
      padding: "0.25rem 0.5rem",
      background: "linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%)",
      borderRadius: "6px",
    },
    stockSuccess: {
      color: "#10b981",
      fontSize: "0.8125rem",
      fontWeight: 600,
      margin: 0,
      padding: "0.35rem 0.75rem",
      background: "linear-gradient(135deg, #d1fae5 0%, #dcfce7 100%)",
      borderRadius: "6px",
      display: "inline-block",
    },
    stockWarning: {
      color: "#f59e0b",
      fontSize: "0.8125rem",
      fontWeight: 600,
      margin: 0,
      padding: "0.35rem 0.75rem",
      background: "linear-gradient(135deg, #fed7aa 0%, #fde68a 100%)",
      borderRadius: "6px",
      display: "inline-block",
    },
    stockDanger: {
      color: "#ef4444",
      fontSize: "0.8125rem",
      fontWeight: 600,
      margin: 0,
      padding: "0.35rem 0.75rem",
      background: "linear-gradient(135deg, #fecaca 0%, #fca5a5 100%)",
      borderRadius: "6px",
      display: "inline-block",
    },
    shippingWrapper: {
      marginTop: "0.25rem",
    },
    divider: {
      height: "1px",
      background: "linear-gradient(90deg, transparent, #e2e8f0 50%, transparent)",
      margin: "0.5rem 0",
      border: "none",
    },
  };

  // Animations CSS - UNIQUEMENT AU HOVER
  const animationStyles = `
/* Animation d'entrée : UNE SEULE FOIS */
@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Bounce pour boutons : UNIQUEMENT AU HOVER */
@keyframes buttonBounce {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}

.card-landscape {
  animation: cardSlideIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) both;
}

/* HOVER : animations déclenchées uniquement au survol */
.card-landscape:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 8px 24px rgba(0, 115, 153, 0.15);
  border-color: #00a4d8;
}

.image-wrapper-landscape {
  flex-shrink: 0;
  min-width: 120px;
  min-height: 120px;
  max-width: 220px;
  max-height: 220px;
  border-radius: 10px;
  overflow: hidden;
//   border: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
//   box-shadow: 0 2px 8px rgba(0, 115, 153, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

/* Halo sur l'image : UNIQUEMENT AU HOVER de la card */
.image-wrapper-landscape::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 50%, rgba(0, 164, 216, 0.15), transparent 70%);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
}

.card-landscape:hover .image-wrapper-landscape::after {
  opacity: 1;
}

/* Effet lift sur image au hover de la card */
.card-landscape:hover .image-wrapper-landscape {
  transform: scale(1.03);
  box-shadow: 0 4px 12px rgba(0, 115, 153, 0.15);
}

/* Bounce bouton : UNIQUEMENT AU HOVER du bouton */
.quantity-button-hover:hover {
  max-width: 40px
  animation: buttonBounce 0.4s ease;
  background: linear-gradient(135deg, #e0f2fe 0%, #ace0fcff 100%);
  color: #007399;
}

/* Responsive */
@media (max-width: 768px) {
  .card-landscape {
    // flex-direction: column;
    align-items: stretch;
  }

  .content-wrapper-landscape {
    display: block;
    width: 100%;
  }
}

@media (max-width: 420px) {
  .image-wrapper-landscape {
    max-width: 120px;
    max-height: 120px;
    margin-bottom: 0.5rem;
  }

  .controls-row-landscape {
    display: block;
  }

  .controls-row-landscape > * {
    display: block;
    margin-bottom: 0.5rem;
    width: 100%;
  }

  .controls-row-landscape > *:last-child {
    margin-bottom: 0;
  }
}

/* Updating state */
.card-updating {
  opacity: 0.6;
  pointer-events: none;
}

/* Respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .card-landscape,
  .quantity-button-hover {
    animation: none !important;
    transition: none !important;
  }
}
`;

  // Inject animations
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = animationStyles;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  // ================== LOGIQUE ORIGINALE ==================

  const updateCart = (c, p) => {
    setIsUpdating(true);
    updateItem(token, { count: c, CartID: p }).then((data) => {
      if (data.error) {
      } else {
        cartItems(token);
      }
      setIsUpdating(false);
    });
  };

  const deleteCart = (c, p) => {
    setIsUpdating(true);
    removeItem(token, { count: c, CartID: p }).then((data) => {
      if (data.error) {
      } else {
        cartItems(token);
      }
      setIsUpdating(false);
    });
  };

  const handleChange = (CartID) => (event) => {
    const value = Number(event.target.value);
    if (value >= 1) {
      let count = value < product.quantity ? value : product.quantity;
      updateCart(count, CartID);
    }

    if (value === 0) {
      deleteCart(value, CartID);
    }
  };

  // Product Bundles: a bundle line moves by whole sets (the server rescales
  // every line of the offer together).
  const step = product.bundle?.groupId ? Number(product.bundle.quantityPerSet) || 1 : 1;

  const buttonMimus = () => {
    let newCount = countProuct;
    newCount -= step;
    if (newCount < 0) newCount = 0;
    if (newCount === 0) {
      deleteCart(newCount, CartID);
    }
    if (newCount >= 1) {
      updateCart(newCount, CartID);
    }
  };

  const buttonPLus = () => {
    let newCount = countProuct;
    if (newCount + step <= product.quantity) {
      newCount += step;
      updateCart(newCount, CartID);
    }
  };

  const buttonDeleteCart = () => {
    deleteCart(0, CartID);
  };

  const delete_Minus = countProuct > 1 ? <FaMinus /> : <MdDelete />;

  const sum = (total, num) => total + Math.round(num);

  const sumVote = product.vote?.map((p) => p.voteNum) || [];
  const rating =
    sumVote.length > 0 ? sumVote.reduce(sum, 0) / product.vote.length : 0;

  const showVote = rating > 0;

  const allfilter = (filter) => {
    let texFil = "";
    for (let fil in filter) {
      texFil += fil + ": " + filter[fil] + " • ";
    }
    return texFil.slice(0, -3);
  };

  const urlFilter = (filter) => {
    let texFil = "";
    for (let fil in filter) {
      texFil += fil + "=" + filter[fil] + "&";
    }
    return "?" + texFil;
  };

  const stock = () => {
    if (product.proFilter.quantity === 0) {
      return (
        <p style={styles.stockDanger}>
          {infoSource.laguangeElakay("text", infoSource.languageAPI).textCardCart1}
        </p>
      );
    } else if (product.proFilter.quantity < 20) {
      return (
        <p style={styles.stockWarning}>
          {infoSource.laguangeElakay("text", infoSource.languageAPI).textCardCart2}{" "}
          {product.proFilter.quantity}{" "}
          {infoSource.laguangeElakay("text", infoSource.languageAPI).textCardCart3}
        </p>
      );
    } else if (product.proFilter.quantity >= 20) {
      return (
        <h6 style={styles.stockSuccess}>
          {infoSource.laguangeElakay("text", infoSource.languageAPI).textCardCart4}
        </h6>
      );
    }
  };

  let urlFil = urlFilter(product.proFilter.filter);

  return (
    <div
      className={`card-landscape ${isUpdating ? 'card-updating' : ''}`}
      style={styles.card}
    >
      {/* Image à gauche */}
      <div className="image-wrapper-landscape" style={styles.imageContainerOuter}>
        <div style={styles.imageContainer}>
          <Showimage
            laguangeElakay={laguangeElakay}
            infoSource={infoSource}
            item={product}
            productId={product.productID}
            categoryId={catalID}
            urlImg={product.urlImg}
            showB={false}
            showShopV={false}
            urlFilter={urlFil}
          />
        </div>
      </div>

      {/* Contenu à droite */}
      <div className="content-wrapper-landscape" style={styles.contentWrapper}>
        {/* Header avec nom et delete */}
        <div className="header-landscape" style={styles.header}>
          <h3 style={styles.productName}>{product.name}</h3>
          <button
            className="delete-button-landscape"
            style={styles.deleteButton}
            onClick={buttonDeleteCart}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.15) rotate(8deg)";
              e.target.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1) rotate(0deg)";
              e.target.style.boxShadow = "0 2px 4px rgba(239, 68, 68, 0.1)";
            }}
            aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).cardCart.t001}
          >
            <FiDelete />
          </button>
        </div>

        {product.bundle?.groupId && (
          <div style={{ fontSize: 13, margin: "4px 0 6px", padding: "6px 10px", borderRadius: 8, background: product.bundle.applied ? "#e6f3f8" : "#fdf3e2", color: product.bundle.applied ? "#004b63" : "#7c2d12" }}>
            <strong>{elakayAutoText("h_bnd_cart_badge", "Combined offer")}{product.bundle.name ? `: ${product.bundle.name}` : ""}</strong>
            {product.bundle.applied
              ? <span>{product.bundle.unitDiscount > 0 ? ` · ${elakayAutoText("h_bnd_cart_saving", "Bundle price")} (-$${Number(product.bundle.unitDiscount).toFixed(2)} / ${elakayAutoText("h_bnd_unit", "unit")})` : ""} · {elakayAutoText("h_bnd_cart_whole", "Quantity and removal apply to the whole offer.")}</span>
              : <span> · {elakayAutoText("h_bnd_cart_not_applied", "This offer no longer applies; regular prices are shown.")}</span>}
          </div>
        )}

        {/* Filtres */}
        {product.proFilter?.filter && (
          <p style={styles.filterText}>{allfilter(product.proFilter.filter)}</p>
        )}

        {/* Contrôles (Quantité + Prix) */}
        <div className="controls-row-landscape" style={styles.controlsRow}>
          <div style={styles.quantityControl}>
            <button
              className="quantity-button-hover"
              style={styles.quantityButton}
              onClick={buttonMimus}
            >
              {delete_Minus}
            </button>
            <input
              type="number"
              min="0"
              max={product.quantity}
              value={countProuct}
              onChange={handleChange(CartID)}
              style={styles.quantityInput}
            />
            <button
              className="quantity-button-hover"
              style={styles.quantityButton}
              onClick={buttonPLus}
              disabled={countProuct >= product.quantity}
            >
              <FaPlus />
            </button>
          </div>

          <div style={styles.priceWrapper}>
            <Price showAddToCartButton={false} products={product} />
          </div>
        </div>

        {/* Infos (Vote + Stock) */}
        <div style={styles.infoRow}>
          {showVote && (
            <div style={styles.voteWrapper}>
              <Vote rating={parseFloat(rating)} />
            </div>
          )}
          {stock()}
        </div>

        <hr style={styles.divider} />

        {/* Shipping */}
        <div style={styles.shippingWrapper}>
          <ShippingCart
            laguangeElakay={laguangeElakay}
            infoSource={infoSource}
            shipAmout={shipAmout}
            SetShipAmount={SetShipAmount}
            token={token}
            Saddress={Saddress}
            products={product}
          />
        </div>
      </div>
    </div>
  );
};

export default CardCart;